import createD3NumberFormatter from './factories/createD3NumberFormatter';
import createSmartNumberFormatter from './factories/createSmartNumberFormatter';
import Formats from './NumberFormats';
import FormatterRegistry from '../FormatterRegistry';
export default class NumberFormatterRegistry extends FormatterRegistry {
  constructor({
    name = 'NumberFormatter',
    ...rest
  } = {}) {
    super({
      name,
      ...rest
    });
    this.registerValue(Formats.SMART_NUMBER, createSmartNumberFormatter());
    this.registerValue(Formats.signed.SMART_NUMBER, createSmartNumberFormatter({
      signed: true
    }));
    this.setDefaultKey(Formats.SMART_NUMBER);
  } // eslint-disable-next-line class-methods-use-this


  createFormatter(format) {
    return createD3NumberFormatter({
      format
    });
  }

}